<template>
  <div class="toolbarTools" v-on-clickaway="closeOpenList">
    <v-layout v-for="(item, index) in visibleObjectOptions" :key="item.layer">
      <standard-item
        v-if="standardItemPermissions(item)"
        :label="item.label"
        :layer="item.layer"
        :icon="item.icon"
        :filled-icon="item.filledIcon"
        :instructions="item.instructions"
        @select-item="selectItem(item)"
        @reset-selected-item="resetSelectedItem"
      />

      <item-with-options
        v-else
        :label="item.label"
        :object-type="item.objectType"
        :default-layer="item.defaultLayer"
        :options="item.options"
        :open-list="openList"
        @select-item="selectItem"
        @reset-selected-item="resetSelectedItem"
        @toggle-options-menu="toggleObjectOptionsList(item.objectType)"
      />

      <v-divider
        vertical
        v-if="index >= 0 && index < visibleObjectOptions.length - 1"
      />
    </v-layout>
  </div>
</template>

<script>
import { bus } from "@/main";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";
import { mixin as clickaway } from "vue-clickaway";
import BuildingSVG from "@/assets/tools_svgs/uni.svg";
import BuildingFillSVG from "@/assets/tools_svgs/uniFill.svg";
import PoleSVG from "@/assets/tools_svgs/pole.svg";
import PoleFillSVG from "@/assets/tools_svgs/poleFill.svg";
import ManholeSVG from "@/assets/tools_svgs/manhole.svg";
import ManholeFillSVG from "@/assets/tools_svgs/manholeFill.svg";
import InfraSVG from "@/assets/tools_svgs/infra.svg";
import InfraFillSVG from "@/assets/tools_svgs/infraFill.svg";
import CableSVG from "@/assets/tools_svgs/cable.svg";
import CableFillSVG from "@/assets/tools_svgs/cableFill.svg";
import ClosureSVG from "@/assets/tools_svgs/closure.svg";
import ClosureFillSVG from "@/assets/tools_svgs/closureFill.svg";
import TowerSVG from "@/assets/tools_svgs/tower.svg";
import TowerFillSVG from "@/assets/tools_svgs/towerFill.svg";
import ClusterSVG from "@/assets/tools_svgs/cluster.svg";
import ClusterFillSVG from "@/assets/tools_svgs/clusterFill.svg";
import ClusterTool from "@/assets/tools_svgs/clusterTool.svg";
import ClusterToolFill from "@/assets/tools_svgs/clusterToolFill.svg";
import CabinetSVG from "@/assets/tools_svgs/cabinet.svg";
import CabinetFillSVG from "@/assets/tools_svgs/cabinetFill.svg";
import TobyBoxSVG from "@/assets/tools_svgs/tobyBox.svg";
import TobyBoxFillSVG from "@/assets/tools_svgs/tobyBoxFill.svg";
import COSVG from "@/assets/tools_svgs/co.svg";
import COFillSVG from "@/assets/tools_svgs/coFill.svg";
import PNSVG from "@/assets/tools_svgs/pn.svg";
import PNFillSVG from "@/assets/tools_svgs/pnFill.svg";
import TechLocalSVG from "@/assets/tools_svgs/techLocal.svg";
import TechLocalFillSVG from "@/assets/tools_svgs/techLocalFill.svg";
import PNAreaSVG from "@/assets/tools_svgs/pnArea.svg";
import PNAreaFillSVG from "@/assets/tools_svgs/pnAreaFill.svg";
import COAreaSVG from "@/assets/tools_svgs/co.svg";
import COAreaFillSVG from "@/assets/tools_svgs/coFill.svg";
import OtherAreaSVG from "@/assets/tools_svgs/otherArea.svg";
import OtherAreaFillSVG from "@/assets/tools_svgs/otherAreaFill.svg";
import ClosureAreaSVG from "@/assets/tools_svgs/closureArea.svg";
import ClosureAreaFillSVG from "@/assets/tools_svgs/closureAreaFill.svg";
import AnnotationPointSVG from "@/assets/tools_svgs/annotationPoint.svg";
import AnnotationPointFillSVG from "@/assets/tools_svgs/annotationPointFill.svg";
import FieldCableSVG from "@/assets/tools_svgs/fieldCable.svg";
import FieldCableFillSVG from "@/assets/tools_svgs/fieldCableFill.svg";
import SlackSVG from "@/assets/tools_svgs/slack.svg";
import SlackFillSVG from "@/assets/tools_svgs/slackFill.svg";
import BulkTPSVG from "@/assets/tools_svgs/bulk_tp.svg";
import BulkTPFillSVG from "@/assets/tools_svgs/bulk_tp_fill.svg";
import BundleSVG from "@/assets/tools_svgs/bundle.svg";
import BundleFillSVG from "@/assets/tools_svgs/bundleFill.svg";
import ExternalImportSVG from "@/assets/tools_svgs/externalImport.svg";
import ExternalImportFillSVG from "@/assets/tools_svgs/externalImportFill.svg";
import VirtualSVG from "@/assets/tools_svgs/virtual.svg";
import VirtualFillSVG from "@/assets/tools_svgs/virtualFill.svg";
import BlockageSVG from "@/assets/tools_svgs/blockage.svg";
import BlockageFillSVG from "@/assets/tools_svgs/blockageFill.svg";
import StandardItem from "@/components/Home/Toolbars/CreateObjects/ItemStandard";
import ItemWithOptions from "@/components/Home/Toolbars/CreateObjects/ItemWithOptions";

export default {
  name: "CreateObjectsToolbar",

  mixins: [checkPermissionsMixin, clickaway],

  components: {
    ItemWithOptions,
    StandardItem
  },

  data() {
    return {
      openList: null
    };
  },

  computed: {
    objectOptions() {
      return [
        {
          label: this.$i18n.tc("DemandPoint", 1),
          objectType: "demandPoint",
          defaultLayer: "fc_building",
          visible: this.canCreate("building") || this.canCreate("site"),
          options: [
            {
              label: this.$i18n.tc("Building", 1),
              layer: "fc_building",
              icon: BuildingSVG,
              filledIcon: BuildingFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: this.canCreate("building")
            },
            {
              label: this.$i18n.tc("Site", 1),
              layer: "fc_site",
              icon: TowerSVG,
              filledIcon: TowerFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: this.canCreate("site")
            }
          ]
        },
        {
          label: this.$i18n.tc("Pathway", 1),
          objectType: "pathway",
          layer: "fc_pathway",
          icon: InfraSVG,
          filledIcon: InfraFillSVG,
          instructions: this.$i18n.t("StartDrawingLineInstruction"),
          visible: this.canCreate("pathway"),
          select: () => {
            this.$emit("enablePathwayCreation");
          }
        },
        {
          label: this.$i18n.tc("TechnicalPoint", 1),
          objectType: "technical_point",
          defaultLayer: "fc_cabinet",
          visible: this.canCreate("technical_point"),
          options: [
            {
              label: this.$i18n.tc("Virtual", 1),
              layer: "fc_virtual",
              icon: VirtualSVG,
              filledIcon: VirtualFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("Pole", 1),
              layer: "fc_pole",
              icon: PoleSVG,
              filledIcon: PoleFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("Manhole", 1),
              layer: "fc_manhole",
              icon: ManholeSVG,
              filledIcon: ManholeFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("Cabinet", 1),
              layer: "fc_cabinet",
              icon: CabinetSVG,
              filledIcon: CabinetFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("TobyBox", 1),
              layer: "fc_toby_box",
              icon: TobyBoxSVG,
              filledIcon: TobyBoxFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            }
          ]
        },
        {
          label: this.$i18n.tc("Closure", 1),
          objectType: "closure",
          layer: "fc_closure",
          icon: ClosureSVG,
          filledIcon: ClosureFillSVG,
          instructions: this.$i18n.t("CreateClosureInstruction"),
          visible: this.designEnabled && this.canCreate("closure")
        },
        {
          label: this.$i18n.tc("TechnicalSite", 1),
          objectType: "technical_site",
          defaultLayer: "fc_fiber_distribution_point",
          visible: this.canCreate("technical_site"),
          options: [
            {
              label: this.$i18n.tc("CentralOffice", 1),
              layer: "fc_optical_line_termination",
              icon: COSVG,
              filledIcon: COFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("PrimaryNode", 1),
              layer: "fc_fiber_distribution_point",
              icon: PNSVG,
              filledIcon: PNFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: true
            }
          ]
        },
        {
          label: this.$i18n.tc("TechnicalLocal", 1),
          objectType: "technical_local",
          layer: "fc_technical_local",
          icon: TechLocalSVG,
          filledIcon: TechLocalFillSVG,
          instructions: this.$i18n.t("CreateTechLocalInstruction"),
          visible: this.canCreate("technical_local")
        },
        {
          label: this.$i18n.tc("Cable", 1),
          objectType: "cable",
          defaultLayer: "fc_cable",
          visible: this.designEnabled && this.canCreate("cable"),
          options: [
            {
              label: this.$i18n.tc("Cable", 1),
              layer: "fc_cable",
              icon: CableSVG,
              filledIcon: CableFillSVG,
              visible: true,
              select: () => {
                this.$emit("enableCableCreation");
              }
            },
            {
              label: this.$i18n.tc("FieldCable", 1),
              layer: "fc_field_cable",
              icon: FieldCableSVG,
              filledIcon: FieldCableFillSVG,
              instructions: this.$i18n.t("CreateFieldCableInstruction"),
              visible: true
            },
            {
              label: this.$i18n.tc("Slack", 1),
              layer: "fc_slack",
              icon: SlackSVG,
              filledIcon: SlackFillSVG,
              instructions: this.$i18n.t("CreateSlackInstruction"),
              visible: this.designEnabled && this.canCreate("slack")
            },
            {
              label: this.$i18n.tc("Bundle", 1),
              layer: "fc_microduct_bundle",
              icon: BundleSVG,
              filledIcon: BundleFillSVG,
              instructions: this.$i18n.t("BundleInstruction"),
              visible: true,
              select: () => {
                this.$emit("enableBundleCreation");
              }
            }
          ]
        },
        {
          label: this.$i18n.tc("Tool", 2),
          objectType: "tool",
          defaultLayer: "fc_fiber_terminal_box",
          visible: this.designEnabled,
          options: [
            {
              label: this.$i18n.tc("Cluster", 1),
              layer: "fc_fiber_terminal_box",
              icon: ClusterSVG,
              filledIcon: ClusterFillSVG,
              visible: this.clusterEnabled,
              select: () => {
                this.$emit("enableClusterCreation");
              }
            },
            {
              label: 'MPR',
              layer: "fc_cluster_tool",
              icon: ClusterTool,
              filledIcon: ClusterToolFill,
              instructions: this.$tc('MultiPointRouting'),
              visible: this.clusterEnabled,
              select: () => {
                this.$emit("enableClusterToolCreation");
              }
            },
            {
              label: this.$i18n.t("BulkTP"),
              layer: "fc_bulk_tp",
              icon: BulkTPSVG,
              filledIcon: BulkTPFillSVG,
              visible: true,
              select: () => {
                this.$emit("enableBulkTPCreation");
              }
            }
          ]
        },
        {
          label: this.$i18n.tc("Area", 1),
          objectType: "area",
          defaultLayer: "fc_annotation_zone",
          visible: this.designEnabled && this.zoneEnabled,
          options: [
            {
              label: this.$i18n.tc("CentralOfficeArea", 1),
              layer: "fc_olt_zone",
              icon: COAreaSVG,
              filledIcon: COAreaFillSVG,
              instructions: this.$i18n.t("StartDrawingPolygonInstruction"),
              visible: this.coZoneEnabled,
              select: () => {
                this.$emit("enableAreaCreation");
              }
            },
            {
              label: this.$i18n.tc("PrimaryNodeArea", 1),
              layer: "fc_fdp_zone",
              icon: PNAreaSVG,
              filledIcon: PNAreaFillSVG,
              instructions: this.$i18n.t("StartDrawingPolygonInstruction"),
              visible: this.pnZoneEnabled,
              select: () => {
                this.$emit("enableAreaCreation");
              }
            },
            {
              label: this.$i18n.tc("ClosureArea", 1),
              layer: "fc_closure_zone",
              icon: ClosureAreaSVG,
              filledIcon: ClosureAreaFillSVG,
              instructions: this.$i18n.t("StartDrawingPolygonInstruction"),
              visible: this.closureZoneEnabled,
              select: () => {
                this.$emit("enableAreaCreation");
              }
            },
            {
              label: this.$i18n.tc("OtherArea", 1),
              layer: "fc_annotation_zone",
              icon: OtherAreaSVG,
              filledIcon: OtherAreaFillSVG,
              instructions: this.$i18n.t("StartDrawingPolygonInstruction"),
              visible: this.otherZoneEnabled,
              select: () => {
                this.$emit("enableAreaCreation");
              }
            }
          ]
        },
        {
          label: this.$i18n.tc("Other", 2),
          objectType: "other",
          defaultLayer: "fc_annotation_point",
          visible: this.designEnabled && this.zoneEnabled,
          options: [
            {
              label: this.$i18n.tc("AnnotationPoint", 1),
              objectType: "annotation_point",
              layer: "fc_annotation_point",
              icon: AnnotationPointSVG,
              filledIcon: AnnotationPointFillSVG,
              instructions: this.$i18n.t("CreateObjectInstruction"),
              visible: this.designEnabled && this.canCreate("annotation_point")
            },
            {
              label: this.$i18n.tc("Blockage", 1),
              objectType: "blockage",
              layer: "fc_blockage",
              icon: BlockageSVG,
              filledIcon: BlockageFillSVG,
              instructions: this.$i18n.t("CreateBlockageInstruction"),
              visible: this.designEnabled && this.canCreate("blockage"),
            }
          ]
        },
        {
          label: this.$i18n.t("ExternalImport"),
          layer: "external_import",
          icon: ExternalImportSVG,
          filledIcon: ExternalImportFillSVG,
          instructions: this.$i18n.t("StartDrawingPolygonInstruction"),
          visible: this.isSuperAdmin || this.isAdmin,
          select: () => {
            this.$emit("enableExternalImport");
          }
        }
      ];
    },

    visibleObjectOptions() {
      let visibleOptions = [];
      for (const item of this.objectOptions) {
        if (item.visible) {
          visibleOptions.push(item);
        }
      }
      return visibleOptions;
    },

    /**
     * Defines the selected object type.
     */
    selectedObjectLayer() {
      return this.$store.getters.tools_selectedObjectLayer;
    },

    /**
     * Defines if the buttons of the Design module are enabled or not.
     */
    designEnabled() {
      return this.userHasModulePermission("module_design");
    },

    /**
     * Defines if the Zone button are enabled or not.
     */
    zoneEnabled() {
      return (
        this.coZoneEnabled ||
        this.pnZoneEnabled ||
        this.closureZoneEnabled ||
        this.otherZoneEnabled ||
        this.clusterEnabled
      );
    },

    coZoneEnabled() {
      return this.canCreate("optical_line_terminations");
    },

    pnZoneEnabled() {
      return this.canCreate("fiber_distribution_point");
    },

    closureZoneEnabled() {
      return this.canCreate("closure_zone");
    },

    otherZoneEnabled() {
      return this.canCreate("annotation_zone");
    },

    clusterEnabled() {
      return this.canCreate("cluster");
    }
  },

  mounted() {
    /**
     * When the component is mounted, makes sure that none of the object buttons is selected.
     */
    bus.$on("deselect-selected-object-to-create", () => {
      this.resetSelectedItem();
    });
  },

  destroyed() {
    bus.$off("deselect-selected-object-to-create");
  },

  methods: {
    canCreate(objectType) {
      return this.userHasFibercloudPermission(objectType, "store");
    },

    standardItemPermissions(item) {
      return !item.options
    },

    selectItem(selectedLayer) {
      if (selectedLayer.hasOwnProperty("select")) {
        selectedLayer.select();
      }
    },

    resetSelectedItem() {
      this.toggleObjectOptionsList(null);

      let lastObject = this.selectedObjectLayer;

      if (lastObject === "fc_cable") {
        bus.$emit("deactivate-cable-creation");
      } else if (lastObject === "fc_fiber_terminal_box") {
        bus.$emit("deactivate-cluster-creation");
      } else if (lastObject === "fc_bulk_tp") {
        bus.$emit("deactivate-bulk_tp_creation");
      } else if (lastObject === "fc_microduct_bundle") {
        bus.$emit("deactivate-bundle_creation");
      } else if (lastObject === "fc_cluster_tool") {
        bus.$emit("deactivate-fc_cluster_tool");
      } else if (lastObject === "external_import") {
        bus.$emit("deactivate-external_import");
      } else {
        if (lastObject === "fc_pathway" || lastObject === "fc_field_cable") {
          this.$emit("resetLineString");
        } else if (lastObject.includes("zone")) {
          this.$emit("resetArea");
        }

        this.$emit("resetSelectedObjectType");
      }
    },

    toggleObjectOptionsList(list) {
      if (list && this.openList !== list) {
        this.openList = list;
      } else {
        this.openList = null;
      }
    },

    closeOpenList() {
      this.openList = null;
    }
  }
};
</script>

<style scoped>
.toolbarTools {
  position: absolute;
  width: fit-content;
  height: 48px;
  bottom: 3%;
  right: 0;
  left: 0;
  margin: 0 auto;
  background-color: white;
  display: inline-flex;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.3);
  border-radius: 30px;
  z-index: 7;
  padding: 0 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Toolbars/CreateObjects/CreateObjectsToolbar.vue